import firebase from 'firebase/compat'
import { useCollectionData } from 'hooks/firebase'
import { IFile } from '.'

export const useUserAttachments = (uid: string) =>
  useCollectionData<IFile>(
    firebase.firestore().collection('users').doc(uid).collection('attachments')
  )
